import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/pro-regular-svg-icons";

export default function LabelFilter({ labels, selectedLabelIds, onToggleLabel, onManageLabels, onClearLabels }) {
    return (
        <div className="library-label-filter">
            {labels.map((label) => {
                const isActive = selectedLabelIds.includes(label.id);
                return (
                    <button
                        key={label.id}
                        className={`library-label-pill ${isActive ? "active" : ""}`}
                        onClick={() => onToggleLabel(label.id)}
                        style={label.color ? { "--label-color": label.color } : {}}
                    >
                        {label.color && <span className="library-label-dot" style={{ backgroundColor: label.color }} />}
                        {label.name}
                        {isActive && (
                            <span className="library-label-dismiss" aria-hidden="true">
                                ×
                            </span>
                        )}
                    </button>
                );
            })}
            {selectedLabelIds.length >= 2 && (
                <button className="library-clear-filters" onClick={onClearLabels}>
                    Wis filters
                </button>
            )}
            <button className="library-label-pill library-label-manage" onClick={onManageLabels} title="Manage labels">
                <FontAwesomeIcon icon={faGear} />
            </button>
        </div>
    );
}
